import { Box, styled } from '@mui/material';

import { OneLinkStyle } from './NavLinksMobile.types';

const linkWidthPadding = 8;
const linkBorderRadius = 8;
const gapBetweenLinks = 8;

export const NavLinksContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: `${gapBetweenLinks}px`,

  margin: 'auto',
}));

export const OneLink = styled(Box)(
  ({ main, secondary, highlight }: OneLinkStyle) => ({
    display: 'flex',

    position: 'relative',
    padding: `5px ${linkWidthPadding}px`,
    borderRadius: `${linkBorderRadius}px`,

    fontSize: '18px',
    color: secondary,
    fontFamily: 'SignikaMedium',

    cursor: 'pointer',

    '&:hover': {
      color: main,
    },

    '&.active': {
      backgroundColor: highlight,
    },

    '&:hover.active': {
      backgroundColor: 'transparent',
    },

    transition: 'background-color .3s linear',
  }),
);
